import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { header } from '../../../routes'
import $ from 'jquery'

import logo from '../../../images/basic/header/logo.svg'
import vector_down from '../../../images/basic/header/vector_down.svg'
import vector_right from '../../../images/basic/header/vector_right.svg'
import styles from './styles.module.scss'

const Header = ({ setActiveForm, setOurRef, setActivePopUp, setActiveButton, activeButton }) => {
  const location = useLocation()
  const prevRoute = (location.state!=null) ? location.state : location.pathname
  const ref = useRef(null)

  useEffect(() => {
    setOurRef(ref)
  }, [])
  const pathRoute = location.pathname
  const [activeStudentButton, setActiveStudentButton] = useState(false)
  const [burger, setBurger] = useState(false)
  const internShipsPage = pathRoute == '/students/internShips'

  const watchId = id => {
    if(id === 4 &&
      (prevRoute == '/' ||
      prevRoute == '/listing' ||
      prevRoute == '/relocation' ||
      (typeof prevRoute == 'object' && prevRoute.route == '/listing'))
    ) {
      // window._tmr = window._tmr || [];
      // window._tmr.push({ type: 'reachGoal', id: 3398932, goal: 'click_otkliknutsya'});
    }
    if (
      id === 4 &&
      ( prevRoute !== '/students/mabstudy' ||
        prevRoute !== '/students/education' ||
        prevRoute !== '/students/internShips')
    ) {
      setActivePopUp(false)
      setActiveForm(true)
      setActiveButton(false)
    }

    if (
      id === 4 &&
      prevRoute === '/students/education'
    ) {
      setActivePopUp(true)
      setActiveForm(false)
      setActiveButton(false)
    }
    if (
      id === 4 &&
      (prevRoute === '/students/mabstudy' || prevRoute === '/students/internShips')
    ) {
      setActivePopUp(false)
      setActiveForm(false)
      setActiveButton(false)
      let btop = $("#form").offset().top - $('#root .layout_header').offset().top - 100
      $("html").animate({
         scrollTop: btop
      }, 2000);

    }

    if (id === 1 || id === 2) {
      setActiveButton(false)
      setActivePopUp(false)
      setActiveForm(false)
    }

    if (id === 1 && prevRoute === '/listing') {
      location.reload();
    }

    id === 3 && setActiveButton(!activeButton)

    setBurger(false)
  }

  const watchIdMobile = id => {
    console.log('header click');
    if (
      id === 4 &&
      (
        prevRoute !== '/students/mabstudy' ||
        prevRoute !== '/students/education' ||
        prevRoute !== '/students/internShips'
      )
    ) {
      setActivePopUp(false)
      setActiveForm(true)
      setBurger(false)
      setActiveStudentButton(false)
    }

    if (
      id === 4 &&
      prevRoute === '/students/education'
    ) {
      setActivePopUp(true)
      setActiveForm(false)
      setBurger(false)
      setActiveStudentButton(false)
    }
    if (
      id === 4 &&
      (
        prevRoute === '/students/mabstudy' ||
        prevRoute === '/students/internShips'
      )
    ) {
      setActivePopUp(false)
      setActiveForm(false)
      setActiveButton(false)
      let btop = $("#form").offset().top - $('#root .layout_header').offset().top - 80
      $("html").animate({
        scrollTop: btop
      }, 2000);
    }
  }
  const closeBurgerAndPoPup = () => {
    setBurger(false)
    setActiveStudentButton(false)
    setActivePopUp(false)
    setActiveForm(false)
  }
  const closeMobileForm = () => {
    setActivePopUp(false)
    setActiveForm(false)
    setBurger(false)
  }
  const prevRouteForm = prevRoute + "#form"

  return (
    <div ref={ref} className="layout_header">
      <div className="layout_header_fixed">
      <div className={styles.wrapper}>
        <Link to='/' state='/' className={styles.logo_wrap} onClick={closeBurgerAndPoPup}>
          <img src={logo} alt='logo' className={styles.logo} />
        </Link>
        <div className={styles.wrapper_block}>
          {header.map(item => (
            internShipsPage && item.id === 4 ? "" :
            (<div key={item.id} className={item.to === prevRoute ? styles.buttons_active : styles.buttons}>
              {item.id === 0 && <a className={styles.buttons_nav} target='_blank' href={item.to}>{item.title}</a>}
              {item.id !== 0 && (
              <Link
                onClick={() => watchId(item.id)}
                className={item.id != 4 ? styles.buttons_nav : styles.buttons_nav_rightSide}
                to={item.to === '/students' ? null : item.to}
                state={!item.to ? prevRoute : item.to}
              >
                {item.title}
                {activeButton && item.id === 3 && (
                  <div className={styles.modal}>
                    <Link className={styles.modal_navLink} to='/students/education' state='/students/education'>
                      Образовательные программы
                    </Link>
                    <Link className={styles.modal_navLink} to='/students/internShips' state='/students/internShips'>
                      Стажировки
                    </Link>
                    <Link className={styles.modal_navLink2} to='/students/mabstudy' state='/students/mabstudy'>
                      Проект Mabstudy
                    </Link>
                  </div>
                )}
                {item.id === 3 && (
                  <img
                    src={vector_down}
                    className={!activeButton ? styles.vector_down : styles.vector_down_reverse}
                    alt='vector'
                  />
                )}
                {item.id === 4 && <p>&rarr;</p>}
               </Link>
                )}
            </div>)
          ))}
        </div>
      </div>
      </div>

      {/*мобильный адаптив*/}

      <div className={burger ? styles.wrapper_block_mobile_full : styles.wrapper_block_mobile}>
        <div className={styles.header_block}>
          <Link to='/' state='/' className={styles.logo_wrap} onClick={closeMobileForm}>
            <img src={logo} alt='logo' className={styles.logo} />
          </Link>
          <div onClick={(e) => {setBurger(!burger); e.stopPropagation(); }} className={styles.wrapper_menu}>
            <p>Меню</p>
            <img className={burger ? styles.vector_up : styles.vector_down} src={vector_right} alt='vector' />
          </div>
        </div>
        {burger && (
          <div className={styles.header_down}>
            {header
              .filter(elem => elem.id < 3 && elem.id < 4)
              .map(item => (
                <div key={item.id} className={styles.buttons}>
                  <Link
                    onClick={() => watchId(item.id)}
                    className={styles.buttons_nav}
                    to={item.to === '/students' ? null : item.to}
                    state={!item.to ? prevRoute : item.to}
                  >
                    {item.title}
                  </Link>
                </div>
              ))}
            <div
              className='flex w-full justify-between text-base pb-2 mb-3'
              onClick={() => setActiveStudentButton(!activeStudentButton)}
            >
              <p>Студенты</p>
              <img
                src={vector_down}
                className={!activeStudentButton ? styles.vector_down : styles.vector_down_reverse}
                alt='vector'
              />
            </div>
            {activeStudentButton && (
              <div className={styles.modal}>
                <Link
                  className={styles.modal_navLink}
                  to='/students/education'
                  state='/students/education'
                  onClick={closeBurgerAndPoPup}
                >
                  Образовательные программы
                </Link>
                <Link
                  className={styles.modal_navLink}
                  to='/students/internShips'
                  state='/students/internShips'
                  onClick={closeBurgerAndPoPup}
                >
                  Стажировки
                </Link>
                <Link
                  className={styles.modal_navLink2}
                  to='/students/mabstudy'
                  state='/students/mabstudy'
                  onClick={closeBurgerAndPoPup}
                >
                  Проект Mabstudy
                </Link>
              </div>
            )}
            {!internShipsPage ? (<div
              className={styles.bottom_buttons}
              onClick={() => watchIdMobile(4)}
            >
              Откликнуться <span>&rarr;</span>
            </div>) : ""}
          </div>
        )}
      </div>
    </div>
  )
}

export default Header
